<template>
    <u-select-outlined-tile v-model="modelValue" v-bind="$attrs" @input="$emit('input', modelValue)">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-select-outlined-tile>
</template>

<script>
import USelectOutlinedTile from "@/components/publish/styles/forms/u-select-outlined-tile.vue";

export default {
    props: {
        value: { type: String, default: null },
    },
    components: {
        USelectOutlinedTile,
    },
    data() {
        return {
            modelValue: this.$props.value,
        };
    },
    watch: {
        value() {
            this.modelValue = this.value;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
